if (!customElements.get('en-five-add')) {
  customElements.define('en-five-add', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('submit', async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        if (!button || button.disabled) return;
        const error = this.querySelector('[role="alert"]');
        const status = this.querySelector('[data-add-status]');
        const drawer = document.querySelector('cart-drawer');
        const originalError = error?.textContent || '';
        const wasDisabled = button.disabled;
        let added = false;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (error) error.hidden = true;
        if (status) status.textContent = '';
        try {
          if (!drawer || typeof drawer.getSectionsToRender !== 'function' || typeof drawer.renderContents !== 'function') throw new Error('Drawer unavailable');
          const sections = drawer.getSectionsToRender().map((section) => section.id).slice(0, 5);
          if (!sections.length) throw new Error('Drawer sections unavailable');
          drawer.setActiveElement?.(button);
          const body = new FormData(form);
          body.set('sections', sections.join(','));
          body.set('sections_url', window.location.pathname);
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body,
            signal: AbortSignal.timeout(30000)
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            if (error && typeof result.description === 'string') error.textContent = result.description;
            throw new Error('Cart rejected');
          }
          added = true;
          if (status) status.textContent = this.dataset.added || '';
          if (sections.some((id) => typeof result.sections?.[id] !== 'string')) {
            const url = new URL(window.location.href);
            url.searchParams.set('sections', sections.join(','));
            const refresh = await fetch(url, { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(15000) });
            if (!refresh.ok) throw new Error('Drawer refresh failed');
            result.sections = await refresh.json();
          }
          if (sections.some((id) => typeof result.sections?.[id] !== 'string')) throw new Error('Drawer sections missing');
          drawer.classList.remove('is-empty');
          drawer.renderContents(result);
        } catch {
          if (added) drawer?.open?.(button);
          if (error) {
            if (error.textContent === originalError && added && this.dataset.refreshError) error.textContent = this.dataset.refreshError;
            error.hidden = false;
          }
        } finally {
          button.disabled = wasDisabled;
          button.removeAttribute('aria-busy');
        }
      });
    }
  });
}
